import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" Are you sure? ");
import { Table, Button, Icon, ModalBox, Alert } from '@/components/UI';
import { ScheduleTemplateForm } from '@/components/Schedule';
import useScheduleTemplates from '@/compositions/useScheduleTemplates';
import { cloneDeep } from 'lodash';
import { computed, ref } from 'vue';
import { useToast } from 'vue-toastification';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const toast = useToast();
        const { deleteScheduleTemplate, updateScheduleTemplate } = useScheduleTemplates();
        const { scheduleTemplates } = useScheduleTemplates();
        const requestDeleteId = ref(null);
        const editTemplateId = ref(null);
        const editableTemplate = ref(null);
        const fields = [
            { key: 'name', name: 'Name', sortable: true },
            { key: 'actions', name: 'Actions', sortable: false }
        ];
        const items = computed(() => {
            return Object.entries(scheduleTemplates.value).map(([id, template]) => {
                return { name: template.name, id };
            });
        });
        const showDelete = (id) => {
            requestDeleteId.value = id;
        };
        const deleteTemplate = async () => {
            if (requestDeleteId.value === null)
                return;
            const result = await deleteScheduleTemplate(requestDeleteId.value);
            requestDeleteId.value = null;
            if (result) {
                toast.success("Successfully deleted the template");
            }
            else {
                toast.error("Could not delete the template");
            }
        };
        const editTemplate = (id) => {
            editTemplateId.value = id;
            editableTemplate.value = cloneDeep(scheduleTemplates.value[id]);
        };
        const closeEdit = () => {
            editTemplateId.value = null;
            editableTemplate.value = null;
        };
        const updateTemplate = async () => {
            if (editTemplateId.value === null || editableTemplate.value === null)
                return;
            const result = await updateScheduleTemplate({
                id: editTemplateId.value,
                template: editableTemplate.value
            });
            closeEdit();
            if (result) {
                toast.success("Successfully updated the template");
            }
            else {
                toast.error("Could not updated the template");
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(Table), {
                    striped: "",
                    hover: "",
                    items: _unref(items),
                    fields: fields
                }, {
                    actions: _withCtx((row) => [
                        _createVNode(_unref(Button), {
                            size: "sm",
                            variant: "success",
                            onClick: ($event) => (editTemplate(row.item.id))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Icon), { name: "pencil" })
                            ]),
                            _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_unref(Button), {
                            size: "sm",
                            variant: "danger",
                            onClick: ($event) => (showDelete(row.item.id))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Icon), { name: "trash" })
                            ]),
                            _: 2
                        }, 1032, ["onClick"])
                    ]),
                    _: 1
                }, 8, ["items"]),
                (requestDeleteId.value)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 0,
                        submitButtonTitle: "Delete",
                        onSubmit: deleteTemplate,
                        onClose: _cache[0] || (_cache[0] = ($event) => (requestDeleteId.value = null))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Alert), {
                                show: "",
                                variant: "danger"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_1
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (editTemplateId.value)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 1,
                        submitButtonTitle: "Edit Schedule Template",
                        onSubmit: updateTemplate,
                        onClose: closeEdit
                    }, {
                        default: _withCtx(() => [
                            (editableTemplate.value)
                                ? (_openBlock(), _createBlock(_unref(ScheduleTemplateForm), {
                                    key: 0,
                                    modelValue: editableTemplate.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editableTemplate).value = $event))
                                }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
